//#region src/utils/deepMerge.ts
var isMergeable = (value) => typeof value === "object" && value !== null;
var hasKey = (target, key) => isMergeable(target) && key in target;
var isUnsafeKey = (target, key) => hasKey(target, key) && !Object.prototype.propertyIsEnumerable.call(target, key);
var clone = (value) => isMergeable(value) ? merge(Array.isArray(value) ? [] : {}, value) : value;
function mergeObject(target, source) {
	const destination = {};
	if (isMergeable(target)) for (const key of Object.keys(target)) destination[key] = clone(target[key]);
	for (const key of Object.keys(source)) {
		if (isUnsafeKey(target, key)) continue;
		destination[key] = hasKey(target, key) && isMergeable(source[key]) ? merge(target[key], source[key]) : clone(source[key]);
	}
	return destination;
}
function merge(target, source) {
	const sourceIsArray = Array.isArray(source);
	if (sourceIsArray !== Array.isArray(target)) return clone(source);
	return sourceIsArray ? target.concat(source).map(clone) : mergeObject(target, source);
}
function deepMerge(target, source) {
	return merge(target, source);
}
//#endregion
export { deepMerge };
